export default __webpack_public_path__ + "static/media/marzitelli.cf34e8f7.png";